import JSZip from 'jszip'
import fetch from 'isomorphic-fetch'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'

async function fetchUploadUrl(upload_url, fileName) {
  const response = await railsPostFetch(upload_url, {
    method: 'POST',
    body: JSON.stringify({
      contentType: 'application/zip',
      fileName
    })
  })
  const data = await response.json()
  if ('OK' != data.status) throw new Error('Bad response from server')
  return data
}

export default function GoogleUpload(upload_url = '', surveyId, fileName = '', files = []) {
  return new Promise((resolve, reject) => {
    if (!files.length) {
      resolve()
    } else {
      const zip = new JSZip()

      files.forEach(v =>
        'image' == v.type ? zip.file(v.filename, v.content, { base64: true }) : zip.file(v.filename, v.content)
      )

      /// receive url for upload
      Promise.all([
        fetchUploadUrl(upload_url, `${surveyId}/${fileName}`),
        zip.generateAsync({
          type: 'blob'
        })
      ])
        .then(result => {
          const [data, fileBlob] = [...result]

          fetch(data.url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/zip'
            },
            body: fileBlob
          })
            .then(response => {
              if (200 == response.status) {
                resolve(data)
              } else {
                reject(new Error('Bad response from server'))
              }
            })
            .catch(reject)
        })
        .catch(reject)
    }
  })
}
